import { Injectable } from '@angular/core';
import moment from "moment/moment";

@Injectable({
  providedIn: 'root'
})
export class TextUtilsService {

  constructor() { }

  fromNowToString(recent: Date | string) {
    let result = moment(recent).format("D MMMM h:mm a");
    const date = new Date(recent)
    if (this.isFromPreviousYear(date)) {
      result = moment(date).format("LLLL");
    }
    if (this.isWithinPastWeek(date)) {
      result = moment(date).calendar()
    }
    if (this.isWithinPastTwoHours(date)) {
      result = moment(date).fromNow()
    }
    return result
  }


  isOlderThanHours(datep: Date | string, hours: number): boolean {
    let date: Date = datep as any;
    if (typeof datep === typeof "123") {
      date = new Date(datep);
    }
    const now = new Date();
    const oneDayAgo = now.getTime() - hours * 60 * 60 * 1000; // 24 hours in ms
    return date.getTime() < oneDayAgo;
  }

  isWithinPastWeek(date: Date) {
    const now = new Date();
    const sevenDaysInMs = 7 * 24 * 60 * 60 * 1000;
    const diff = now.getTime() - date.getTime();

    // Is the difference positive (in the past) and less than 7 days?
    return diff <= sevenDaysInMs;
  }

  isFromPreviousYear(date: Date) {
    const currentYear = new Date().getFullYear();
    const targetYear = date.getFullYear();
    return targetYear === currentYear - 1;
  }

  isWithinPastTwoHours(date: Date) {
    const now = new Date();
    const twoHoursInMs = 2 * 60 * 60 * 1000;
    const diff = now.getTime() - date.getTime();

    return diff <= twoHoursInMs;
  }
}
